module.exports = __webpack_public_path__ + "img/hello-card.6b81497e.jpg";